export default __webpack_public_path__ + "locales/pt-BR/Settings.json?hash=3dfce9211ace0f19870f0fcb3114e20d";